import { memo } from 'react';
import Questioner, { IQuestioner } from './questioner';
import Respondent, { IRespondent } from './respondent';
import System, { ISystem } from './system';
import classNames from 'classnames';
import './index.scss';

export type IQaRecordItem = { recordId: string } & (IQuestioner | IRespondent | ISystem);

interface IProps {
    list: IQaRecordItem[];
    preventClick?: boolean;
}

const QaRecords = ({ list, preventClick }: IProps) => {
    return (
        <div className={classNames('qa-record', preventClick && 'qa-record__prevent-click')}>
            {list.map(item => {
                switch (item.role) {
                    case 'questioner':
                        return <Questioner key={item.recordId} {...item} />;
                    case 'respondent':
                        return <Respondent key={item.recordId} {...item} />;
                    case 'system':
                        return <System key={item.recordId} {...item} />;
                    default:
                        return null;
                }
            })}
        </div>
    );
};

export default memo(QaRecords);
